import { Injectable } from '@angular/core';
import { SafeResourceUrl, DomSanitizer } from '@angular/platform-browser';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable()
export class IframeService {
  private iframeUrlSource: BehaviorSubject<SafeResourceUrl> = new BehaviorSubject<SafeResourceUrl>('');
  iframeUrl$: Observable<SafeResourceUrl> = this.iframeUrlSource.asObservable();

  constructor(private dom: DomSanitizer) {}

  updateIframeUrl(url: string): void {
    const sanitizedUrl = this.dom.bypassSecurityTrustResourceUrl(url);
    this.iframeUrlSource.next(sanitizedUrl);
  }
}
